import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  alrayyanSwitching,
  getAppId,
  getVCMS,
  getAlrayyanStatus,
} from "../../api/api";
import { jwStore } from "../../store/necStore";
import LabelImage from "../cards/image";
import Vidgyor from "./vidgyor";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
// import { UserLang } from "../../store/userStore";

const Live = (props) => {
  const initState = {
    cloudName: props.type,
    cloudKey: "",
    liveCloudName: "",
    cloudSecret: "",
    cloudKeyV2: "",
    cloudSecretV2: "",
    mainAccountId: "",
    secondAccountId: "",
    firstPlayer: "",
    secondPlayer: "",
    premiumPlayer: "",
    licenseKey: "",
    iosLicenseKey: "",
    premLicenseKey: "",
    iosPremLicenseKey: "",
    secLicenseKey: "",
    iosSecLicenseKey: "",
    drmKey: "",
    drmMobileKey: "",
    drmTVKey: "",
    searchPlaylist: "",
    recommendedPlaylist: "",
    watchPlaylist: "",
  };
  const [live, setLive] = useState([]);
  const [editing, setEditing] = useState(initState);
  const [hold, setHold] = useState([]);
  const [lan] = useState("ltr");
  const [loading, setLoading] = useState(false);
  const [altv, setAlTV] = useState("");
  const [oltv, setOlTV] = useState("");
  const [alatv, setAlaTV] = useState("");
  const [olatv, setOlaTV] = useState("");
  // const lan = UserLang.useState((s) => s.lan);
  /*   const [modalShow, setModalShow] = useState(false);
  const [allImage,setallImage] = useState([]);
  const [pageModalShow, setPageModalShow] = useState(false);
  */
  const option = [
    {
      value: "VIDGYOR",
      label: (
        <LabelImage
          url={"https://www.vidgyor.com/assets/images/Logo.png"}
          name={"VIDGYOR"}
          height={"30px"}
        >
          {" "}
        </LabelImage>
      ),
    },
    {
      value: "JWPlayer",
      label: (
        <LabelImage
          url={
            "https://upload.wikimedia.org/wikipedia/en/thumb/6/69/JW_Player_logo.png/330px-JW_Player_logo.png"
          }
          height={"30px"}
        >
          {" "}
        </LabelImage>
      ),
    },
  ];

  const alrayyanM = async (event) => {
    setLoading(true);
    // event.preventDefault();
    //
    // const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */
    event.preventDefault();
    switching("alrayyan", "primary");

    /* eslint-disable no-unused-vars */
  };

  const oAlrayyanM = async (event) => {
    setLoading(true);
    // event.preventDefault();
    //
    // const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */
    event.preventDefault();
    switching("oldrayyan", "primary");
    /* eslint-disable no-unused-vars */
  };

  const alrayyanB = async (event) => {
    setLoading(true);
    // event.preventDefault();
    //
    // const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */
    event.preventDefault();
    switching("alrayyan", "backup");
    /* eslint-disable no-unused-vars */
  };

  const oAlrayyanB = async (event) => {
    setLoading(true);
    // event.preventDefault();
    //
    // const pageid = props.match.params.id;
    /* eslint-disable no-unused-vars */
    event.preventDefault();
    switching("oldrayyan", "backup");
    /* eslint-disable no-unused-vars */
  };

  useEffect(() => {
    const videoDetail = async () => {
      /* eslint-disable no-unused-vars */
      setLoading(true);
      const result = await getVCMS().then(
        (result) => {
          jwStore.update((s) => {
            s.jw = result.data;
          });
          setEditing(result.data);

          setLoading(false);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
    };
    const ActiveStatus = async () => {
      /* eslint-disable no-unused-vars */
      const alresult = await getAlrayyanStatus(
        "https://35lbvikvo8.execute-api.us-east-2.amazonaws.com/PROD/v1/stream_type?channel=alrayyan"
      ).then(
        (result) => {
          setAlTV(result);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );

      const olresult = await getAlrayyanStatus(
        "https://35lbvikvo8.execute-api.us-east-2.amazonaws.com/PROD/v1/stream_type?channel=oldrayyan"
      ).then(
        (result) => {
          setOlTV(result);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
      const alaresult = await getAlrayyanStatus(
        "https://35lbvikvo8.execute-api.us-east-2.amazonaws.com/PROD/v1/stream_type?channel=alrayyan_audio"
      ).then(
        (result) => {
          setAlaTV(result);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );

      const olaresult = await getAlrayyanStatus(
        "https://35lbvikvo8.execute-api.us-east-2.amazonaws.com/PROD/v1/stream_type?channel=oldrayyan_audio"
      ).then(
        (result) => {
          setOlaTV(result);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
        }
      );
    };

    const appId = async () => {
      setHold(getAppId);
      if (getAppId() === "63a73eba71dc820fb05e7928") {
        ActiveStatus();
      }
    };

    appId();
    videoDetail();
  }, [live, hold]);

  const switching = async (name, stream) => {
    const result = await alrayyanSwitching(name, stream).then(
      (result) => {
        // setStore(result.data);

        toastr.success("Successfully Switched", "Success");
        setLoading(false);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
        setLoading(false);
      }
    );
  };

  const setLiveChange = (value, evt) => {
    // const value = evt.target.value;
    setEditing({
      ...editing,
      [evt.name]: value.value,
    });
  };

  const liveChange = (value) => {
    setLive(value);
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Live Stream Account
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row">
                          {lan === "rtl" && <div className="col-md-4"></div>}
                          <div
                            className="col-md-8 float-right"
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                          >
                            <label
                              className={
                                lan === "rtl" ? "float-right" : "float-left"
                              }
                            >
                              Live Stream
                            </label>
                            <Select
                              name="liveCloudName"
                              className="form-control inside-select float-right"
                              options={option}
                              onChange={(value, event) =>
                                setLiveChange(value, event)
                              }
                            ></Select>
                            <div
                              className="row"
                              style={{
                                marginTop: "100px",
                                backgroundColor: "#f2f2f2",
                              }}
                            >
                              <div
                                className="col-md-12"
                                style={{ marginTop: "20px" }}
                              >
                                <label
                                  className={
                                    lan === "rtl" ? "float-right" : "float-left"
                                  }
                                >
                                  {editing.liveCloudName}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4"></div>
                        </div>

                        {editing.liveCloudName === "VIDGYOR" &&
                          hold === "63a73eba71dc820fb05e7928" && (
                            <>
                              <div className="row mb-2 mt-2"></div>
                              <div className="row mb-2 mt-2"></div>

                              {/* </>
}

{(editing.liveCloudName==="VIDGYOR"&&hold==="")&&
  <> */}
                              <div className="row mb-2 mt-2"></div>
                              <div className="row mb-2 mt-2"></div>

                              <div className="row">
                                <div className="col-sm-12">
                                  <table
                                    id="appadmin"
                                    className="table table-bordered table-hover dataTable dtr-inline"
                                    role="grid"
                                    aria-describedby="example2_info"
                                    dir={lan === "rtl" ? "rtl" : "ltr"}
                                  >
                                    <thead>
                                      <tr role="row">
                                        <th
                                          className="sorting_asc"
                                          tabIndex={0}
                                          aria-controls="example2"
                                          rowSpan={1}
                                          colSpan={1}
                                        >
                                          <label
                                            className={
                                              lan === "rtl"
                                                ? "float-right"
                                                : "float-left"
                                            }
                                          >
                                            Channel Name
                                          </label>
                                        </th>
                                        <th>
                                          <label
                                            className={
                                              lan === "rtl"
                                                ? "float-right"
                                                : "float-left"
                                            }
                                          >
                                            Status
                                          </label>
                                        </th>
                                        <th>
                                          <label
                                            className={
                                              lan === "rtl"
                                                ? "float-right"
                                                : "float-left"
                                            }
                                          >
                                            Current Stream
                                          </label>
                                        </th>
                                        <th
                                          className="sorting"
                                          tabIndex={0}
                                          aria-controls="example2"
                                          rowSpan={1}
                                          colSpan={1}
                                        >
                                          <label
                                            className={
                                              lan === "rtl"
                                                ? "float-right"
                                                : "float-left"
                                            }
                                          >
                                            Switch to Main/Backup
                                          </label>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Alrayyan TV</td>
                                        <td>
                                          {altv ? (
                                            altv.data.status === "success" ? (
                                              <label className="text-success">
                                                Success
                                              </label>
                                            ) : (
                                              <label className="text-danger">
                                                {altv.data.status}
                                              </label>
                                            )
                                          ) : (
                                            <label className="text-warning">
                                              No Data
                                            </label>
                                          )}
                                        </td>
                                        <td>
                                          {altv
                                            ? altv.data.stream_type ===
                                              "primary"
                                              ? "Running Main Stream"
                                              : "Running Backup Stream"
                                            : ""}
                                        </td>
                                        <td>
                                          <div className="form-group">
                                            <div
                                              className={
                                                lan === "rtl"
                                                  ? "float-right custom-control custom-switch"
                                                  : "float-left custom-control custom-switch"
                                              }
                                            >
                                              <a
                                                href="#!"
                                                className="btn btn-info mt-2"
                                                onClick={(event) =>
                                                  alrayyanB(event)
                                                }
                                              >
                                                Switch to Backup Stream
                                              </a>
                                              <a
                                                href="#!"
                                                className="btn btn-warning ml-2 mt-2"
                                                onClick={(event) =>
                                                  alrayyanM(event)
                                                }
                                              >
                                                Switch to Main Stream
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>oldrayyan TV</td>
                                        <td>
                                          {oltv ? (
                                            oltv.data.status === "success" ? (
                                              <label className="text-success">
                                                Success
                                              </label>
                                            ) : (
                                              <label className="text-danger">
                                                {oltv.data.status}
                                              </label>
                                            )
                                          ) : (
                                            <label className="text-warning">
                                              No Data
                                            </label>
                                          )}
                                        </td>
                                        <td>
                                          {oltv
                                            ? oltv.data.stream_type ===
                                              "primary"
                                              ? "Running Main Stream"
                                              : "Running Backup Stream"
                                            : ""}
                                        </td>
                                        <td>
                                          <div className="form-group">
                                            <div
                                              className={
                                                lan === "rtl"
                                                  ? "float-right custom-control custom-switch"
                                                  : "float-left custom-control custom-switch"
                                              }
                                            >
                                              <a
                                                href="#!"
                                                className="btn btn-primary bg-green mt-2"
                                                style={{
                                                  border: "1px solid #1e7e34",
                                                }}
                                                onClick={(event) =>
                                                  oAlrayyanB(event)
                                                }
                                              >
                                                Switch to Backup Stream
                                              </a>
                                              <a
                                                href="#!"
                                                className="btn btn-primary bg-dark ml-2 mt-2"
                                                style={{
                                                  border: "1px solid #000000",
                                                }}
                                                onClick={(event) =>
                                                  oAlrayyanM(event)
                                                }
                                              >
                                                Switch to Main Stream
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Alrayyan FM</td>
                                        <td>
                                          {alatv ? (
                                            alatv.data.status === "success" ? (
                                              <label className="text-success">
                                                Success
                                              </label>
                                            ) : (
                                              <label className="text-danger">
                                                {alatv.data.status}
                                              </label>
                                            )
                                          ) : (
                                            <label className="text-warning">
                                              {"No Data"}
                                            </label>
                                          )}
                                        </td>
                                        <td>
                                          {alatv
                                            ? alatv.data.stream_type ===
                                              "primary"
                                              ? "Running Main Stream"
                                              : "Running Backup Stream"
                                            : ""}
                                        </td>
                                        <td>
                                          <div className="form-group">
                                            <div
                                              className={
                                                lan === "rtl"
                                                  ? "float-right custom-control custom-switch"
                                                  : "float-left custom-control custom-switch"
                                              }
                                            >
                                              <a
                                                href="#!"
                                                className="btn btn-info mt-2"
                                                onClick={(event) =>
                                                  alrayyanB(event)
                                                }
                                              >
                                                Switch to Backup Stream
                                              </a>
                                              <a
                                                href="#!"
                                                className="btn btn-warning ml-2 mt-2"
                                                onClick={(event) =>
                                                  alrayyanM(event)
                                                }
                                              >
                                                Switch to Main Stream
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Sawt AL Islam Radio</td>
                                        <td>
                                          {olatv ? (
                                            olatv.data.status === "success" ? (
                                              <label className="text-success">
                                                Success
                                              </label>
                                            ) : (
                                              <label className="text-danger">
                                                {olatv.data.status}
                                              </label>
                                            )
                                          ) : (
                                            <label className="text-warning">
                                              No Data
                                            </label>
                                          )}
                                        </td>
                                        <td>
                                          {olatv
                                            ? olatv.data.stream_type ===
                                              "primary"
                                              ? "Running Main Stream"
                                              : "Running Backup Stream"
                                            : ""}
                                        </td>
                                        <td>
                                          <div className="form-group">
                                            <div
                                              className={
                                                lan === "rtl"
                                                  ? "float-right custom-control custom-switch"
                                                  : "float-left custom-control custom-switch"
                                              }
                                            >
                                              <a
                                                href="#!"
                                                className="btn btn-info mt-2"
                                                onClick={(event) =>
                                                  alrayyanB(event)
                                                }
                                              >
                                                Switch to Backup Stream
                                              </a>
                                              <a
                                                href="#!"
                                                className="btn btn-warning ml-2 mt-2"
                                                onClick={(event) =>
                                                  alrayyanM(event)
                                                }
                                              >
                                                Switch to Main Stream
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                    <tfoot>
                                      <tr style={{ border: "none" }}>
                                        <td colSpan={4}></td>
                                      </tr>
                                      <tr className="bg-gray">
                                        <td colSpan={2}>
                                          <small>
                                            * Main Stream Running from ALrayyan
                                            TV premises in Qatar
                                          </small>
                                        </td>
                                        <td colSpan={2}>
                                          <small>
                                            * Backup Stream Running from
                                            Technity System office premises in
                                            Qatar
                                          </small>
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                  {editing.liveCloudName === "VIDGYOR" ||
                  editing.liveCloudName === "JWPlayer" ? (
                    <Vidgyor type={editing}></Vidgyor>
                  ) : (
                    ""
                  )}
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default Live;
